import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditUserGroupReport from "./components/ListAllAuditUserGroupReport";

export default function AuditUserGroupReportTable() {
    const { translate } = useLang();
    
    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('User group')}`} />
            <ListAllAuditUserGroupReport />
        </>
    )
}